import React, { useEffect } from "react";
import PageChrome, { BuyButton, INK, LIME, BLUE, BG_ALT } from "./components/PageChrome";
import { PRODUCTS } from "./products";

const BENEFITS = [
  ["Biblioteca de plantillas viva", "Term sheets, loan tapes y checklists de data room — actualizados y listos para usar."],
  ["Office hours en vivo cada mes", "Sesiones de trabajo conmigo: traes tu deal, lo desarmamos juntos."],
  ["Análisis premium", "El archivo completo + ediciones extendidas con el análisis a fondo."],
  ["Comunidad privada", "Founders, CFOs y prestamistas del ecosistema — intros y deal-flow real."],
  ["Intel de mercado", "Qué fondos están activos, a qué precio y con qué apetito. Antes que nadie."],
  ["Descuentos en todo", "Precio de miembro en cursos, certificación y cohortes."],
];

const PLANS = [
  { p: PRODUCTS.circle_founder, tag: "FUNDADOR · PRIMEROS 100", highlight: true, note: "Precio de por vida mientras seas miembro." },
  { p: PRODUCTS.circle_monthly, tag: "MENSUAL", highlight: false, note: "Cancela cuando quieras." },
  { p: PRODUCTS.circle_annual, tag: "ANUAL", highlight: false, note: "Dos meses gratis vs. mensual." },
];

export default function Circle() {
  useEffect(() => { document.title = "The Debt Circle · Membresía · The Debt Guy"; }, []);
  return (
    <PageChrome active="/circle" testid="circle-page">
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "80px 40px 40px" }} data-testid="circle-hero">
        <div className="cg-mono cg-eyebrow">— Membresía · ingreso recurrente</div>
        <h1 className="cg-h1" style={{ marginTop: 18, maxWidth: 900 }} data-testid="circle-hero-title">
          The Capital <span style={{ color: BLUE }}>Circle.</span>
        </h1>
        <p style={{ marginTop: 22, fontSize: 19, lineHeight: 1.55, opacity: 0.78, maxWidth: 640 }}>
          Tu acceso continuo al playbook, las plantillas, el deal-flow y a mí. Para los que levantan capital todo el año — no una sola vez.
        </p>
      </section>

      {/* Benefits */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "30px 40px 20px" }} data-testid="circle-benefits">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 16 }}>
          {BENEFITS.map(([t, d], i) => (
            <div key={i} className="cg-card" style={{ padding: 26 }}>
              <span className="cg-mono" style={{ color: BLUE, fontSize: 11 }}>{String(i + 1).padStart(2, "0")}</span>
              <div className="cg-h3" style={{ marginTop: 12, fontSize: 20 }}>{t}</div>
              <div style={{ marginTop: 10, opacity: 0.76, lineHeight: 1.5, fontSize: 14.5 }}>{d}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Plans */}
      <section style={{ maxWidth: 1100, margin: "0 auto", padding: "50px 40px 40px" }} data-testid="circle-plans">
        <div className="cg-mono cg-eyebrow">— Elige tu plan</div>
        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 18 }}>
          {PLANS.map(({ p, tag, highlight, note }) => (
            <div key={p.key} className="cg-card" data-testid={`circle-plan-${p.key}`}
              style={{ padding: 30, background: highlight ? INK : BG_ALT, color: highlight ? "#FFFFFF" : INK, boxShadow: highlight ? `6px 6px 0 ${BLUE}` : `5px 5px 0 ${INK}` }}>
              <div className="cg-mono" style={{ color: highlight ? LIME : BLUE, fontSize: 10 }}>{tag}</div>
              <div style={{ marginTop: 18, display: "flex", alignItems: "baseline", gap: 8 }}>
                <span style={{ fontWeight: 900, fontSize: 44, letterSpacing: "-0.04em" }}>{p.usd}</span>
                <span style={{ fontSize: 15, fontWeight: 700, opacity: 0.6 }}>/{p.interval} USD</span>
              </div>
              <div className="cg-mono" style={{ opacity: 0.55, fontSize: 10, marginTop: 6 }}>≈ {p.mxn} / {p.interval}</div>
              <div style={{ marginTop: 14, fontSize: 14, opacity: 0.8, lineHeight: 1.5, minHeight: 42 }}>{note}</div>
              <div style={{ marginTop: 20 }}>
                <BuyButton lookupKey={p.key} testid={`circle-buy-${p.key}`}
                  className={highlight ? "" : "cg-btn-blue"} style={{ width: "100%", color: highlight ? INK : "#FFFFFF" }}>
                  Unirme →
                </BuyButton>
              </div>
            </div>
          ))}
        </div>
        <p className="cg-mono" style={{ marginTop: 20, opacity: 0.5, fontSize: 10 }}>
          Pago seguro con Stripe · cancela cuando quieras · sin permanencia
        </p>
      </section>
    </PageChrome>
  );
}
